import React from 'react';

import {ServerStatus} from 'features/server/model/Server/IServer';
import {colorServerStatus, getServerStatusLabel} from 'features/server/lib/serverStatusHelper';
import StatusBadge from 'shared/ui/Status/StatusBadge';

interface IServerStatusBadgeProps {
    status: ServerStatus,
}

const ServerStatusBadge: React.FC<IServerStatusBadgeProps> = ({status}) => (
    <StatusBadge color={colorServerStatus(status)} label={getServerStatusLabel(status)}/>
);

export default ServerStatusBadge;
